import axios from 'axios'
import mutations from '@/store/mutation-types'
import actions from '@/store/action-types'

export default {
  state: {
    donations: []
  },
  mutations: {
    [ mutations.update.LATEST_DONATE ] (state, payload) {
      state.donations = payload.donations
    }
  },
  actions: {
    [ actions.fetch.LATEST_DONATE ] ({ commit, rootState }) {
      return axios.get(`${rootState.API_BASE_URL}/latest`, {
        params: rootState.urlParams
      }).then(({ data }) => {
        commit(mutations.update.LATEST_DONATE, data)
      }).catch(error => {
        console.log(`${actions.fetch.LATEST_DONATE}: ${error}`)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js